import React from 'react';
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { styles } from '@tag/tag-components-react-v2';
import { Doc } from '../../Docs/DocTypes';
import { getCssForSectionButton } from './NavUtils';
type NavSectionProps = {
  doc: Doc;
  type: string;
  onClick?: (doc: Doc) => void;
  docsDarkModeValue: boolean;
};
export const NavSection: React.FC<NavSectionProps> = (props: NavSectionProps) => (
  <button
    onClick={() => {
      if (props.onClick) {
        props.onClick(props.doc);
      }
    }}
    css={getCssForSectionButton(
      styles.font.family,
      props.type,
      props.doc.type === 'page',
      props.docsDarkModeValue,
    )}
    key={props.doc.name}
  >
    {props.doc.name}
  </button>
);
